import React from 'react'
import { ResponsiveBullet, Datum } from '@nivo/bullet'
import { initTheme } from '@utils'
import styled from '@emotion/styled'
import { Spinner, useTheme } from '@ss/meta-core-components'
import { IDimension } from '@types'
import { CustomTooltip } from './Tooltip'

interface Props {
  data: Datum[]
  dataCy?: string
  dimensions?: IDimension
  loadingSpinner?: JSX.Element
  minimumRange?: number
  normalizedRanges?: [number, number]
}

export const rangeColors = [
  'transparent',
  '#696969',
  '#989898',
  '#D3D3D3',
  'white',
  'transparent',
]
export const markerColors = '#DB5126'
export const measureColor = '#008000'

/**
 * Componente custom per un grafico di tipo Bullet
 * @param props.data {Datum[]}
 * @param props.dataCy {string=} support test e2e
 * @param props.dimensions {IDimension=} dimensioni del container
 * @param props.loadingSpinner {JSX.Element=} componente custo per lo spinner
 * @param props.minimumRange {number=} range minimo
 * @param props.normalizedRanges {number[] | undefined} range normalizzato
 * @component
 */
export const Bullet: React.FC<Props> = (props) => {
  const {
    dimensions,
    dataCy,
    data,
    loadingSpinner,
    normalizedRanges,
    minimumRange,
  } = props

  const { type } = useTheme()

  const chartProps: any = {
    data,
    margin: { top: 10, right: 50, bottom: 0, left: 90 },
    spacing: 46,
    titleAlign: 'start',
    titleOffsetX: -70,
    measureSize: 0.2,
    minValue: normalizedRanges ? normalizedRanges[0] : 'auto',
    maxValue: normalizedRanges ? normalizedRanges[1] : 'auto',
    tooltip: CustomTooltip(normalizedRanges, minimumRange),
    rangeColors,
    measureColors: measureColor,
    markerColors,
  }

  return (
    <Container
      height={dimensions?.height || '375px'}
      width={dimensions?.width || '100%'}
      data-cy={`${dataCy}-bullet`}
    >
      {!data ? (
        <Loading>
          <Loading>
            {loadingSpinner ? (
              loadingSpinner
            ) : (
              <Spinner data-cy={`${dataCy}-bar-loading`} />
            )}
          </Loading>
          <Loading>Updating chart...</Loading>
        </Loading>
      ) : (
        <>
          <ResponsiveBullet {...chartProps} theme={initTheme(type)} />
        </>
      )}
    </Container>
  )
}

const Container = styled.div<{ height: string; width: string }>`
  height: ${({ height }) => height};
  width: ${({ width }) => width};
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
`

const Loading = styled.div`
  display: grid;
  place-self: center;
  gap: 10px;
`
